import { useDashboard } from '@/features/dashboard/api';
import { useMarketsList } from '@/features/markets/api/marketsList.options';

export const useInitialAppQueries = (enabled: boolean) => {
  const {
    data: markets,
    isSuccess: isMarketsSuccess,
    isError: isMarketsError
  } = useMarketsList(undefined, enabled);
  const {
    data: dashboards,
    isSuccess: isDashboardsSuccess,
    isError: isDashboardsError
  } = useDashboard(enabled);

  return {
    areMarketsDone: markets !== undefined || isMarketsSuccess || isMarketsError,
    areDashboardsDone: dashboards !== undefined || isDashboardsSuccess || isDashboardsError
  };
};
